import { useQuery } from "@tanstack/react-query";
import { getMethod } from "../function/helper";

const usePackage = () => {
  const { data: packages } = useQuery({
    queryKey: ["listOfPackages"],
    queryFn: () =>
      getMethod("/package/v1/list").then(res => {
        if (res && res.status === 200) {
          return res.data;
        }

        return [];
      }),

    staleTime: Infinity,
    gcTime: Infinity,
  });

  const calculatePackagingPrice = ({
    type,
    width,
    length,
    height,
    need = true,
  }) => {
    try {
      if (!need) return 0;
      if (type === 0) return 0;
      if (!width || !height || !length) return 0;

      const packageType = packages?.find(item => item.id === type);
      if (!packageType) return 0;

      const rawPrice =
        width * height * length * packageType.coefficient +
        packageType.base_price;

      // افزایش 10 درصدی
      return Math.ceil(rawPrice * 1.1);
    } catch (error) {
      return 0;
    }
  };

  return { calculatePackagingPrice, packages };
};

export default usePackage;
